(function(){
  document.addEventListener('DOMContentLoaded', function() {

    /*
     * Banner video (sections/video-banners.liquid).
     *
     * The video itself lives in the <template> of a <deferred-media> element and
     * is only built into the page when the poster is clicked, so it has to be
     * created and started from here. Only the video for the breakpoint that is
     * actually rendered is created: .desktop is display:none below 750px and
     * .mobile is display:none above it (see base.css).
     *
     * There are deliberately no scroll/touchstart listeners here: the previous
     * version set currentTime = 0.001 and called play() on every banner video on
     * every scroll event, which restarted the video on any scroll and kept it
     * stuck on the first frame while the page was scrolling.
     *
     * The video is not paused when it scrolls out of the viewport: it keeps
     * playing, so coming back to the banner shows the frame the video has
     * reached by then.
     */
    var BANNER_MOBILE_MAX_WIDTH = 749;
    var bannerResizeTimer;

    function isBannerMobileViewport() {
      return window.innerWidth <= BANNER_MOBILE_MAX_WIDTH;
    }

    function isBannerRenderedOnCurrentBreakpoint(element) {
      if ( element.classList.contains('desktop') ) return !isBannerMobileViewport();
      if ( element.classList.contains('mobile') ) return isBannerMobileViewport();
      return true;
    }

    function playBannerVideo(video) {
      if ( ! video ) return;
      video.muted = true;
      video.playsInline = true;
      var playAttempt = video.play();
      // autoplay can be refused by the browser (low power mode, data saver)
      if ( playAttempt && typeof playAttempt.catch === 'function' ) {
        playAttempt.catch(function() {});
      }
    }

    function createBannerVideo(deferredMedia) {
      if ( deferredMedia.dataset.bannerStarted ) return deferredMedia.querySelector('video');
      var video = deferredMedia.querySelector('video');
      if ( ! video ) {
        var mediaTemplate = deferredMedia.querySelector('template');
        if ( ! mediaTemplate || typeof deferredMedia.loadContent !== 'function' ) return null;
        // playsinline must be on the cloned element before playback starts,
        // otherwise iOS opens the video fullscreen instead of playing inline
        mediaTemplate.content.querySelectorAll('video').forEach(function(templateVideo) {
          templateVideo.setAttribute('playsinline', '');
        });
        // focus = false: focusing the video would scroll the page on load
        deferredMedia.loadContent(false);
        video = deferredMedia.querySelector('video');
      }
      deferredMedia.dataset.bannerStarted = 'true';
      return video;
    }

    function syncBannerVideos() {
      document.querySelectorAll('.banner_section deferred-media').forEach(function(deferredMedia) {
        if ( ! isBannerRenderedOnCurrentBreakpoint(deferredMedia) ) {
          var hiddenVideo = deferredMedia.querySelector('video');
          if ( hiddenVideo ) hiddenVideo.pause();
          return;
        }
        var video = createBannerVideo(deferredMedia);
        if ( video && video.paused && ! video.ended ) playBannerVideo(video);
      });
    }

    syncBannerVideos();
    window.addEventListener('resize', function() {
      clearTimeout(bannerResizeTimer);
      bannerResizeTimer = setTimeout(syncBannerVideos, 200);
    });
    // a background tab or a bfcache restore can leave the video paused
    document.addEventListener('visibilitychange', function() {
      if ( ! document.hidden ) syncBannerVideos();
    });
    window.addEventListener('pageshow', syncBannerVideos);
    document.addEventListener('shopify:section:load', function(event) {
      if ( event.target.querySelector('.banner_section') ) syncBannerVideos();
    });

    var playButtonMulti = document.querySelectorAll('.multicolumn .deferred-media__poster-button');
    if ( playButtonMulti.length > 0 ) {
      setTimeout(function() {
        playButtonMulti.forEach( elem => {
          elem.click();
        });
      }, 100);
    }
    

    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(event) {
        let value = Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1);
        this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
        if ( parseInt(value, 10) == 1 ) {
          this.classList.add('filled');
        } else {
          this.classList.remove('filled');
        }
      }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);
    
    /*
    * start code for hover menu open
    */
    const inlineMenu = document.querySelector(".header__inline-menu");
    const detailsItems = inlineMenu.querySelectorAll("details");
      detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul.mega-menu__list");
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
          item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        });
      });
     /*
    * end start code for hover menu open
    */
    
    document.addEventListener('click', function(e) {
      if ((e.target.classList.contains('complementary_item') || e.target.closest('.complementary_item')) && e.target.closest('product-recommendations')  && ! e.target.closest('.card__content')) {
        let $this = e.target.classList.contains('complementary_item') ? e.target : e.target.closest('.complementary_item');
        // console.log($this);
        $this.classList.toggle('active');
      }
    });

    document.addEventListener('click', function(e) {
      if ((e.target.classList.contains('add_look_to_cart') || e.target.closest('.add_look_to_cart')) && e.target.closest('product-recommendations') && ! e.target.closest('.card__content')) {
        let $this = e.target.classList.contains('add_look_to_cart') ? e.target : e.target.closest('.add_look_to_cart');
        e.preventDefault();
        let parentThis = $this.closest('aside');
        let formData = {'items': []};
        let productsItems = parentThis.querySelectorAll('.complementary_item.active .product-variant-id');
        
        productsItems.forEach( item => {
          let productID = item.value;
          formData.items.push({'id': productID,'quantity': 1});
        });
        console.log(formData);
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          console.log(response);
            if ( response.status == 200 ) {
              $.ajax({
                url: '/?section_id=cart-drawer',
                type: 'GET',
                dataType: 'html',
                success: function(carthtml) {
                  let cartDraw = document.querySelector('cart-drawer');
                  let tempElem = document.createElement('div');
                  tempElem.innerHTML = carthtml;
                  let cartNewContent = tempElem.querySelector('.drawer').innerHTML;
                  cartDraw.innerHTML = cartNewContent;
                  cartDraw.classList.remove('is-empty');
                  cartDraw.classList.add('active');
                  document.querySelector('body').classList.add('overflow-hidden');
                  document.querySelector('quick-add-modal[open]')?.removeAttribute('open');
                  let cartCounter = document.querySelector('#cart-icon-bubble');
                  let cartCounterBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
                  let itemsSize = document.querySelectorAll('#CartDrawer-CartItems .cart-item').length;
                  if ( cartCounterBubble ) {
                    let textCounter = `<span aria-hidden="true">${itemsSize}</span><span class="visually-hidden">${itemsSize} items</span>`;
                    cartCounterBubble.innerHTML = textCounter;
                  } else {
                    let counter = document.createElement('div');
                    let textCounter = `<div class="cart-count-bubble"><span aria-hidden="true">${itemsSize}</span><span class="visually-hidden">${itemsSize} items</span></div>`;
                    cartCounter.insertAdjacentHTML('beforeend', textCounter);
                  }
                }
              });
            } else {
              alert('Something goes wrong, write to support.');
            }
          
        })
        .catch((error) => {
          console.error('Error:', error);
        })
      }
    });

    /*
    * code for close menu mobile
    */
    let closeMenuCustom = document.querySelector('.close_menu');
    closeMenuCustom.addEventListener('click', function(e) {
      e.preventDefault();
      let HD = this.closest('header-drawer');
      let HDIcon = HD.querySelector('summary.header__icon');
      HDIcon.click();
    });

    
    window.tempInputs = [];
    document.addEventListener('change', function(e) {
      if (e.target.matches('quick-add-modal variant-selects [type="radio"]')) {
        if ( ! window.tempInputs.includes(e.target.id) ) {
          window.tempInputs.push(e.target.id);
        }
        
      }
    });
    document.addEventListener('click', function(e) {
      if ( e.target.matches('quick-add-modal variant-selects [type="radio"] + label') || e.target.closest('label.swatch-input__label')) {
        // debugger;
       let idInput;
        if ( e.target.closest('label.swatch-input__label') ) {
          idInput = e.target.closest('label.swatch-input__label').previousElementSibling.getAttribute('id');
        } else {
          idInput = e.target.previousElementSibling.getAttribute('id');
        }
        idInput = idInput.replace(/\s+/g, '');
        let targetId = document.querySelector(`[id*="${idInput}"]`).getAttribute('id');
        if ( ! window.tempInputs.includes(targetId) ) {
          window.tempInputs.push(targetId);
        }
        e.target.closest('fieldset').classList.add('active');

        let anotherFieldset = document.querySelectorAll('quick-add-modal variant-selects fieldset:not(.active) [type="radio"]:checked');
        
        // let alreadyFilledInput = document.querySelector(`#${idInput}:checked`);
        let alreadyFilledInput = document.querySelector(`[id="${idInput}"]:checked`);
        if ( anotherFieldset && alreadyFilledInput ) {
          anotherFieldset.forEach( elem => {
            elem.removeAttribute('checked');
          });
        }
        
      }
    });


    function menuOpener() {
      // Проверяем наличие параметра в URL
      const urlParams = new URLSearchParams(window.location.search);
      
      if (urlParams.get('open_menu') === 'true') {
        // Находим кнопку открытия мобильного меню в теме Dawn
        const menuTrigger = document.querySelector('.header__icon--menu');
        
        if (menuTrigger) {
          // Небольшая задержка, чтобы тема успела полностью инициализироваться
          setTimeout(() => {
            menuTrigger.click();
            
            // Опционально: очищаем URL от параметра, чтобы при перезагрузке меню не открывалось снова
            const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
          }, 100);
        }
      }
    }
    menuOpener();
    

    
  }, false);
})();

